


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import moment from 'moment'

@Component({})
export default class TopReferersTableCard extends Vue {
  @Prop(String) title!: string
  @Prop(String) subtitle!: string
  @Prop(Object) data!: object
  @Prop(Boolean) isLoading!: boolean;
  @Prop(Boolean) isPageLoading!: boolean;
  @Prop(Number) total!: number;
  pagination: object = {};
  active: number = 0;
  headers: object = [
            {
                text: 'URL',
                sortable: false,
            },
            {
                text: 'Ilość',
                sortable: false,
                value: 'count'
            }
        ];

  @Watch('pagination')
  onPagination() {
    this.$emit('loadData', this.pagination);
  }

}
